/**
 * 新闻流
 * props:
 *   content { Array }               : 信息流的数据
 *   isDisplaySource { boolean }     : 是否显示新闻来源
 *   columnId { number }             : 碎片id
 *   isEnd { boolean }               : 是否已显示全部，true 已显示全部，false 还有数据
 *   repeatedID { Array<string> }    : 信息流内用于排重的id数组
 *   isScrollLoadingData { boolean } : 是否滚动加载
 *   isPic { boolean }               : 是否为大图模式
 *   isDisplayLoadingMore { boolean }: 是否显示加载更多
 */

import { addEventListener } from '@ifeng/ui_base';
import React, { PureComponent, createRef } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import styles from './index.css';

import { getColumnInfo2 } from '../../services/api';
import { getImage } from '../../utils/cutImg';
import { formatTime } from '../../utils/formatTime';
import { formatUrl } from '../../utils/formatUrl';
import { rel as relText } from '../../utils/rel';

const CardStream = errorBoundary(
    class extends PureComponent {
        static propTypes = {
            content: PropTypes.array,
            columnId: PropTypes.any,
            isEnd: PropTypes.bool,
            repeatedID: PropTypes.arrayOf(PropTypes.string),
            isScrollLoadingData: PropTypes.bool,

            isDisplayLoadingMore: PropTypes.bool,
        };
        static defaultProps = {
            isEnd: false,
            repeatedID: [],
            isScrollLoadingData: false,
            isDisplayLoadingMore: true,
        };

        constructor(...argv) {
            super(...argv);

            this.list = createRef();
            this.countMapCache = {}; // 文章评论数，用于判断评论的数据是否已经读取
            this.countMap = {}; // 文章评论数，渲染list后清空
            this.lastItem = null; // 最后一条数据
            this.state = {
                content: this.props.content, // 文章列表
                isEnd: this.props.isEnd, // 是否结束
                isLoading: false, // 是否加载中
            };

            if (this.props.isScrollLoadingData) {
                this.unlistenerHandleWindowScroll = addEventListener(window, 'scroll', this.handleWindowScroll);
            }
        }
        componentDidMount() {
            // this.getCount();
        }
        handleWindowScroll = () => {
            if (this.state.isLoading === false || this.state.getDataError === false) {
                const scroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                const current = this.list.current;
                const top = current.offsetTop + current.clientHeight;

                if (scroll + (window.innerHeight || document.documentElement.clientHeight) >= top - 50) {
                    this.handleGetColumnInfoClick();
                }
            }
        };

        // 加载更多
        handleGetColumnInfoClick = async () => {
            this.setState({
                isLoading: true,
            });

            try {
                const time = new Date(this.lastItem.newsTime).getTime();

                // throw new Error('12');

                const { data } = await getColumnInfo2(this.lastItem.id, time, 16, this.props.columnId);

                this.setState(
                    {
                        content: this.state.content.concat(data.newsstream),
                        isEnd: data.isEnd,
                        isLoading: false,
                    },
                    this.countCallback,
                );
            } catch (err) {
                console.error(err);
                this.setState({
                    isLoading: false,
                    getDataError: true,
                });
            }
        };

        // 获取image的url
        getImageUrl(item) {
            if ('picUrl' in item) {
                return item.picUrl;
            } else {
                return item.url;
            }
        }

        renderCardCell(item, url, index) {
            const image = item.thumbnails ? item.thumbnails.image : [];
            const __image = image[0] ? getImage(this.getImageUrl(image[0]), 240, 135) : '';

            return (
                <li
                    key={`${item.id}_${item.creator}_${item.newsTime}`}
                    data-id={item.id}
                    className={(index + 1) % 4 === 0 ? styles.mr0 : ''}>
                    <a href={url} title={item.title} target="_blank" rel={relText} className={styles.list_img}>
                        <p>
                            <img src={__image} />
                        </p>
                        {item.type === 'video' ? <div className={styles.video_icon} /> : null}
                        <h1>{item.title}</h1>
                        <span>{formatTime(item.newsTime)}</span>
                    </a>
                </li>
            );
        }
        // 渲染list
        listView(list) {
            this.countMap = {};
            const endIndex = list.length - 1;
            const id = [];

            return list.map((item, index) => {
                // 获取最后一位的信息，用于加载信息流
                if (index === endIndex) this.lastItem = item;

                // 和推荐位或信息流本身的id去重
                if (this.props.repeatedID.includes(item.id) || id.includes(item.id)) return null;

                // 将已渲染id加入到数组
                const idKey = `list_${item.id}`;

                id.push(idKey);

                // 格式化url
                const url = formatUrl(item.url);

                return this.renderCardCell(item, url, index);
            });
        }
        // 查看更多
        moreView() {
            return this.state.isEnd ? <span className={styles.is_end}>已显示全部</span> : '';
        }
        render() {
            const { content } = this.state;

            if (content.length === 0) {
                return (
                    <div>
                        <div className={styles.more_box}>
                            <span className={styles.is_end}>暂无数据</span>
                        </div>
                    </div>
                );
            } else {
                return (
                    <div className={styles.list}>
                        {/* 新闻列表 */}
                        <ul ref={this.list} className={styles.clearfix}>
                            {this.listView(content)}
                        </ul>
                        {/* 点击查看更多 */}
                        {this.props.isDisplayLoadingMore ? (
                            <div className={styles.more_box}>
                                {this.state.isLoading ? (
                                    <span className={styles.is_end}>加载中...</span>
                                ) : (
                                    this.moreView()
                                )}
                            </div>
                        ) : null}
                    </div>
                );
            }
        }
    },
);

export { CardStream };
export default CardStream;
